// Room at the bottom of the page for things fixed to the bottom of the viewport.
//
// Two things float there: the cookie banner and the feedback box (#437). Each reserves
// space so that nothing ends up permanently underneath it:
//
// - padding-bottom keeps the END of the document clear, so the footer is reachable once
//   you scroll all the way down.
// - scroll-padding-bottom keeps anything clear that the browser scrolls INTO view. Tabbing
//   to an off-screen control scrolls it just inside the viewport edge, which is underneath
//   a bottom-fixed box. Without this the element is focused and invisible (WCAG 2.4.11), and
//   padding-bottom does nothing about it, because the problem is mid-page, not at the end.
//
// They used to write those properties directly, which meant whichever ran last won: the
// banner's ResizeObserver fires even while the banner is hidden, and cleared the space the
// feedback box had just claimed. So each owner states what it needs, and the page reserves
// the largest claim.
var claims = {};

export function claimBottomSpace(owner, px) {
    if (px > 0) {
        claims[owner] = px;
    } else {
        delete claims[owner];
    }

    var max = 0;
    for (var key in claims) {
        if (claims[key] > max) max = claims[key];
    }

    var value = max > 0 ? max + 'px' : '';
    document.body.style.paddingBottom = value;
    document.documentElement.style.scrollPaddingBottom = value;
}
